<template>
    <div class="main-content bg-default">
        <!-- Navbar -->
        <base-nav-auth class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  showToggleButton=false
                  expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <h1 class="display-3 logoName">MSacco</h1>
            </router-link>

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <h1 class="display-4 logoName">MSacco</h1>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->

            </template>
        </base-nav-auth>
        <!-- Header -->
        <div class="header  py-7 py-lg-8">

            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">

                    </div>
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                            &copy; {{year}} <a href="https://www.kirigokaranja.com" class="font-weight-bold ml-1"
                                               target="_blank">Sharon Kirigo</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false
      }
    }
  }
</script>
<style>
    @import url("https://fonts.googleapis.com/css?family=Dancing+Script|Satisfy&display=swap");
    .logoName{
        font-family: 'Dancing Script', cursive;
        color: white;
        text-transform: none;
    }
</style>
